import styled from 'styled-components';

export const Notification = styled.div`
  font: 400 20px/24px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.fontColor};
  padding: 16px;
  text-align: center;
`;
